import { useState, useEffect } from 'react'
import axios from 'axios'
import { Pagination, Spin } from 'antd'

export default function PhysiqueTest() {
  const [physiqueTestData, setPhysiqueTestData] = useState({})
  const [currentPage, setCurrentPage] = useState(1)
  const [isLoading, setIsLoading] = useState(true)

  const getPhysiqueTestData = () => {
    axios.post('/admin/forms/physique_test/records/get', { 
      page: currentPage, 
      per_page: 20
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setIsLoading(false)
          setPhysiqueTestData({
            'total_page': response.data.total_page,
            'current_page': response.data.current_page,
            'total': response.data.total,
            'records': response.data.records
          })
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getPhysiqueTestData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage])

  return (
    <div className="public-page">
      <Spin spinning={isLoading}>
        <div className="public-container">
          <div className="public-header">
            <div className="public-title">体测记录</div>
          </div>

          <div className='public-main-style'>
            <div className='public-main-style2'>
              <table className='public-main-style2-item'>
                <thead>
                  <tr className='public-main-style2-thead'>
                    <th style={{textAlign: 'left', paddingLeft: '25px', paddingRight: '20px'}}>测试时间</th>
                    <th style={{paddingRight: '50px'}}>
                      <div className='public-main-style2-title'>测试用户</div>
                    </th>
                    <th style={{paddingRight: '50px'}}>30秒坐站测试(个)</th>
                    <th style={{paddingRight: '50px'}}>30秒手臂弯举(个)</th>
                    <th style={{paddingRight: '50px'}}>2分钟踏步测试(个)</th>
                    <th style={{paddingRight: '50px'}}>椅式坐位体前屈(cm)</th>
                    <th style={{paddingRight: '50px'}}>背抓测试(cm)</th>
                    <th style={{paddingRight: '50px'}}>2.4m绕行测试(s)</th>
                  </tr>
                </thead>

                <tbody>
                  {physiqueTestData.records && (physiqueTestData.records.length > 0 ? (physiqueTestData.records.map((item) => (
                    <tr className='public-main-style2-tbody' key={item.oid} style={{ cursor: 'default'}}>
                      <td style={{textAlign: 'left', paddingLeft: '20px', paddingRight: '20px'}}>{item.submission_time}</td>
                      <td>
                        <div className='public-main-style2-tuwen' style={{paddingRight: '50px'}}>
                          <img src={item.user_avatar_url} alt="" style={{width: '30px', height: '30px'}}/>
                          <span>{item.user_name}</span>
                        </div>
                      </td>
                      <td style={{paddingRight: '50px'}}>{item.sit_stand_count}({item.sit_stand_evaluation})</td>
                      <td style={{paddingRight: '50px'}}>{item.arm_curl_count}({item.arm_curl_evaluation})</td>
                      <td style={{paddingRight: '50px'}}>{item.step_count}({item.step_evaluation})</td>
                      <td style={{paddingRight: '50px'}}>{item.chair_reach_distance}({item.chair_reach_evaluation})</td>
                      <td style={{paddingRight: '50px'}}>{item.back_scrape_distance}({item.back_scrape_evaluation})</td>
                      <td style={{paddingRight: '50px'}}>{item.walk_time}({item.walk_evaluation})</td>
                    </tr>
                  ))) : (
                    <tr className='public-main-style2-tbodyEmpty'>
                      <td colSpan='8'><span>暂无数据</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className='pagination'>
              <Pagination 
                current={currentPage}
                total={physiqueTestData.total}
                pageSize={20}
                onChange={(page) => setCurrentPage(page)}
                showTotal={(total) => `共${total}条`}
                showSizeChanger={false}
                hideOnSinglePage={true}
                showQuickJumper={true}
              />
            </div>
          </div>
        </div>
      </Spin>
    </div>
  )
}
